
const filtroBusquedaState = {
  loading: null,
  tiposAtencion: [],
  modalNuevaPrestacion: false,
  solicitudEnCurso: false,
  filtros: {
    tipoAtencion: "",
  },
  prestaciones: [],
  solicitudes: [],
  modalCargarBorrador: false,
  prestacionesSolicitud: [],
  idSolicitud: null,
};

export default filtroBusquedaState;
